import { apiUrl } from "../utils/api";
import type { ParsedMailFile } from "./mailFileService";
import type { BackendMailDetail } from "./graphMailService";

export type CaptureState = "pending" | "stored" | "failed" | "skipped" | "purged" | "missing";
export type RenderState = "ready" | "limited" | "encrypted" | "unavailable";
export interface LinkedMailArchiveDto {
    archiveId: number | null;
    state: CaptureState;
    storedAt: string | null;
    renderState: RenderState;
    warnings: string[];
    retryAllowed: boolean;
    /** Zahl der Anhänge der gesicherten Mail (T-170) — Büroklammer in der Kontaktansicht. */
    anhaenge?: number;
}
export type LinkedMailContentDto =
    | { source: "archive"; linkId: number; archive: LinkedMailArchiveDto; mail: ParsedMailFile }
    | { source: "live"; linkId: number; archive: LinkedMailArchiveDto; mail: BackendMailDetail }
    | { source: "unavailable"; linkId: number; archive: LinkedMailArchiveDto; message: string };
async function request(linkId: number, suffix: string, method = "GET"): Promise<Response> {
    const response = await fetch(apiUrl(`mail/links/${linkId}/${suffix}`), { method, credentials: "include" });
    if (!response.ok) throw new Error("Die verknüpfte Mail konnte nicht geladen werden.");
    return response;
}
export const linkedMailService = {
    async read(id: number): Promise<LinkedMailContentDto> { return (await request(id, "content")).json(); },
    async downloadOriginal(id: number): Promise<Blob> { return (await request(id, "original")).blob(); },
    async downloadAttachment(id: number, index: number): Promise<Blob> { return (await request(id, `attachments/${index}`)).blob(); },
    async importAttachment(id: number, index: number): Promise<unknown> { return (await request(id, `attachments/${index}/import`, "POST")).json(); },
    async retry(id: number): Promise<LinkedMailArchiveDto> { return (await request(id, "archive/retry", "POST")).json(); },
};
